import FetchByObjectConfig from '../Helpers/FetchByObjectConfig';

export const getLicenseRequest = () => {
    const config = {
        path: 'Licenses',
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}

export const getLicenseHistoricalRequest = () => {
    const config = {
        path: 'Licenses/historical',
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}

export const getBalanceRequest = () => {
    const config = {
        path: 'Licenses/balance',
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}

export const getInvoiceDataRequest = () => {
    const config = {
        path: 'Licenses/invoicedata',
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}

export const saveInvoiceDataRequest = body => {
    const config = {
        path: 'Licenses/invoicedata',
        method: 'POST',
        body
    };
    return FetchByObjectConfig(config);
}
